import React, { PropTypes } from "react";

import ReactDOM from "react-dom";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  NitroHeading,
  NitroText,
  NitroParagraph,
  NitroDivider,
  NitroButtonGroup,
  NitroButton,
  NitroIcon,
  NitroLoading
} from "nitro-components";

import styled from "styled-components";

import * as actions from "./actions";

import { media } from "style-utils";

const Container = styled.div`
  width: 100%;
  flex-basis: 23.5%;
  margin: 10px 0;
  border-radius: 2px;
  background: ${props => props.theme.color.white};
  box-shadow: 0 2px 3px 0 rgba(0,0,0,0.15);
  padding: 12px 30px 8px 30px;

  &:nth-of-type(4n) {
    margin-right: 0px;
  }
`;

const Content = styled.section`
  cursor: pointer;
  display: inline-block;
  border-left: 1px solid;
  border-color: ${props => props.theme.color.border};
  padding-left: 45px;

  > p:first-child {
    width: 90%;
  }
`;

const TimeStamp = styled.section`
  float: right;
`;

const DeleteContainer = styled.a`
  text-decoration: none;
  cursor: pointer;
  margin-left: 10px;

`;

const DeleteConfirmation = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const DeleteButtonGroup = styled.section`
  display: inline-block;
  margin-left: 50px;
  ${media.mobileTablet`
     width: 50%;
  `}
`;

const Heading = styled.section`
  display: inline-block;
  width: 25%;
`;

const ReportName = styled.section`
  background: ${props => props.theme.color.base3};
  border-radius: 100px;
  display: inline-block;
  padding: 0 10px;
`;

const CategoryName = ReportName.extend`
  background: ${props => props.theme.color.base2};
`;
const Divider = styled.section`
  margin: 0 10px;
  display: inline-block;
`;

const LeftContainer = styled.section`
  width: ${props => (!props.condensed && props.deleteVisible ? "70%" : "100%")};
  float:  ${props => (!props.condensed && props.deleteVisible ? "left" : "none")};
  display: ${props => (props.deleteVisible ? "none" : "inline-block")};
  padding: 9px 10px 10px 10px;
`;

const RightContainer = styled.section`
  float: right;
  text-align: ${props => (props.deleteFullWidth ? "center" : "right")};
`;

class NotificationCentreMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmation: false
    };
    this.toggleDeleteConfirmation = this.toggleDeleteConfirmation.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetConfirm !== this.props.resetConfirm) {
      this.state = {
        showDeleteConfirmation: false
      };
    }
  }

  toggleDeleteConfirmation = () => {
    this.setState({
      showDeleteConfirmation: !this.state.showDeleteConfirmation
    });
  };

  confirmDelete = keys => {
    const data = {
      NotificationIds: keys,
      Status: 1 //1-> delete 2-> read
    };
    this.props.actions.deleteNotification(data);
    // this.props.onDelete(data);
  };

  render() {
    const {
      title,
      categoryName,
      timeStamp,
      description,
      company,
      condensed,
      displayDeleteFullWidth,
      minVersion,
      keys,
      reportParam
    } = this.props;
    return (
      <Container>
        <LeftContainer
          deleteVisible={this.state.showDeleteConfirmation}
          deleteFullWidth={displayDeleteFullWidth}
        >
          <Heading>

            <ReportName>
              <NitroText size="5" variant="white" bold>
                {title}
              </NitroText>
            </ReportName>
            <Divider>
              <NitroText size="5" variant="base3" bold>
                <NitroIcon
                  name="arrow-right"
                  size="8"
                  right={6}
                  variant="base3"
                />
              </NitroText>
            </Divider>

            <CategoryName>
              <NitroText size="5" variant="white" bold>
                {categoryName}
              </NitroText>

            </CategoryName>
          </Heading>
          <Content onClick={() => this.props.onClick(reportParam)}>
            <NitroText size="3" variant="notification" bold>
              {description}
            </NitroText>
          </Content>
          <RightContainer>
            {!this.state.showDeleteConfirmation &&
              <TimeStamp>
                <NitroText size="5" variant="base3" noMargin>
                  {timeStamp}
                </NitroText>
                <DeleteContainer onClick={this.toggleDeleteConfirmation}>
                  <NitroIcon
                    name="delete"
                    size="12"
                    right={6}
                    variant="base3"
                    hoverVariant="base2"
                  />
                </DeleteContainer>
              </TimeStamp>}
          </RightContainer>
        </LeftContainer>
        {this.state.showDeleteConfirmation &&
          <DeleteConfirmation>
            <NitroHeading
              size="3"
              variant="base2"
              bold
              label="Delete notification ?"
              align="right"
              header
              noMargin
            />
            <DeleteButtonGroup>
              <NitroButtonGroup layout="horizontal" inline align="center">
                <NitroButton
                  size="extraSmall"
                  label="Yes, delete"
                  variant="notification"
                  action={() => this.confirmDelete(keys)}
                />
                <NitroButton
                  size="extraSmall"
                  label="Cancel"
                  action={this.toggleDeleteConfirmation}
                />
              </NitroButtonGroup>
            </DeleteButtonGroup>
          </DeleteConfirmation>}
      </Container>
    );
  }
}

NotificationCentreMessage.propTypes = {
  title: PropTypes.string,
  categoryName: PropTypes.string,
  timeStamp: PropTypes.string,
  description: PropTypes.string,
  keys: PropTypes.array,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  reportParam: PropTypes.object,
  resetConfirm: PropTypes.bool,
  actions: PropTypes.object,
  deleteInProgress: PropTypes.bool,
  deleteComplete: PropTypes.bool
};

const mapStateToProps = state => ({
  deleteInProgress: state.globalNotification.deleteInProgress,
  deleteComplete: state.globalNotification.deleteComplete
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  NotificationCentreMessage
);



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/NotificationCentreMessage.js